<template>
  <lb-dialog
    v-model="internalValue"
    heading="Upload Net Sales Breakup Commentary"
    :width="width"
    :loading="loading"
  >
    <template v-slot:body>
      <div>
        <div class="d-flex mb-2 gp-1">
          <lb-file
            v-model="fileValue"
            label=""
            :drag="false"
            hidedetails
            @change="onFileChange"
            :displayname="false"
            accept=".xlsx,.xls,.xlsm,.xlsb"
          />
          <v-btn class="secondaryBtn" @click="$emit('download-template')"><span>Download Template</span></v-btn>
        </div>
        <lb-datatable
          v-if="hasData"
          :headers="headers"
          :items="items"
          :enableslot="enableslot"
          :loading="loading"
        >
          <template v-slot:actual_amount="{ item }">
            <span>{{ formatNumber(item.actual_amount) }}</span>
          </template>
          <template v-slot:forecast_amount="{ item }">
            <span>{{ formatNumber(item.forecast_amount) }}</span>
          </template>
          <template v-slot:proforma_amount="{ item }">
            <span>{{ formatNumber(item.proforma_amount) }}</span>
          </template>
          <template v-slot:actual_vs_proforma_variance_amount="{ item }">
            <span>{{ formatNumber(item.actual_vs_proforma_variance_amount) }}</span>
          </template>
          <template v-slot:actual_vs_forecast_variance_amount="{ item }">
            <span>{{ formatNumber(item.actual_vs_forecast_variance_amount) }}</span>
          </template>
          <template v-slot:commentary1="{ item }">
            <span>{{ item?.commentary1 || '' }}</span>
          </template>
          <template v-slot:commentary2="{ item }">
            <span>{{ item?.commentary2 || '' }}</span>
          </template>
          <template v-slot:message="{ item }">
            <span class="error--text" v-if="item.error">{{ item.error }}</span>
            <span class="success--text" v-else>Ok</span>
          </template>
        </lb-datatable>
      </div>
    </template>
    <template v-slot:actions>
      <v-spacer />
      <v-btn
        v-if="showSubmit"
        color="primary"
        @click="$emit('submit')"
      ><span>Submit</span></v-btn>
    </template>
  </lb-dialog>
</template>

<script>
export default {
  name: 'UploadNetSalesCommentaryDialog',
  props: {
    modelValue: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    width: { type: [String, Number], default: 1500 },
    fileValue: { type: [File, null], default: null },
    headers: { type: Array, default: () => [] },
    items: { type: Array, default: () => [] },
    enableslot: { type: Array, default: () => [] },
    showSubmit: { type: Boolean, default: false },
  },
  emits: ['update:modelValue', 'file-change', 'download-template', 'submit', 'update:file-value'],
  computed: {
    internalValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
    hasData() {
      return this.items && this.items.length > 0;
    },
  },
  methods: {
    onFileChange(event) {
      const file = event?.target?.files?.[0] || null;
      this.$emit('update:file-value', file);
      this.$emit('file-change', event);
    },
    formatNumber(value) {
      return this.$nova.formatNumber(value);
    },
  },
};
</script>
